import "../../css/modules/ps_mainmenu/ps_mainmenu_desktop.scss";
import TopMenu from "./top-menu.js";
//$("#menu").remove();

const topMenuEl = $('.js-top-menu ul[data-depth="0"]');
const topMenu = new TopMenu(topMenuEl);
topMenu.init();